/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Mxf_Wrap_HelpInputs */

const en_subtitle_export_mxf_wrap_help = /** @type {(inputs: Subtitle_Export_Mxf_Wrap_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a timed-text MXF file with embedded TTML/XML closed captioning.`)
};

const fr_subtitle_export_mxf_wrap_help = /** @type {(inputs: Subtitle_Export_Mxf_Wrap_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un fichier MXF de texte temporel avec sous-titrage codé TTML/XML intégré.`)
};

const de_subtitle_export_mxf_wrap_help = /** @type {(inputs: Subtitle_Export_Mxf_Wrap_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie eine zeitgesteuerte MXF-Datei mit eingebetteten TTML/XML-Untertiteln.`)
};

const it_subtitle_export_mxf_wrap_help = /** @type {(inputs: Subtitle_Export_Mxf_Wrap_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un file MXF con testo temporizzato con sottotitoli TTML/XML incorporati.`)
};

const ru_subtitle_export_mxf_wrap_help = /** @type {(inputs: Subtitle_Export_Mxf_Wrap_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создайте текстовый файл MXF с временной задержкой и встроенными субтитрами TTML/XML.`)
};

const es_subtitle_export_mxf_wrap_help = /** @type {(inputs: Subtitle_Export_Mxf_Wrap_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cree un archivo MXF de texto cronometrado con subtítulos TTML/XML integrados.`)
};

const zh_cn2_subtitle_export_mxf_wrap_help = /** @type {(inputs: Subtitle_Export_Mxf_Wrap_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建带有嵌入式 TTML/XML 字幕的定时文本 MXF 文件。`)
};

const ja_subtitle_export_mxf_wrap_help = /** @type {(inputs: Subtitle_Export_Mxf_Wrap_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TTML/XML クローズド キャプションが埋め込まれたタイムド テキスト MXF ファイルを作成します。`)
};

const hi_subtitle_export_mxf_wrap_help = /** @type {(inputs: Subtitle_Export_Mxf_Wrap_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एम्बेडेड TTML/XML क्लोज्ड कैप्शनिंग के साथ एक टाइम-टेक्स्ट MXF फ़ाइल बनाएं।`)
};

const pt_pt2_subtitle_export_mxf_wrap_help = /** @type {(inputs: Subtitle_Export_Mxf_Wrap_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um arquivo MXF de texto sincronizado com legendas ocultas TTML/XML incorporadas.`)
};

/**
* | output |
* | --- |
* | "Create a timed-text MXF file with embedded TTML/XML closed captioning." |
*
* @param {Subtitle_Export_Mxf_Wrap_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_mxf_wrap_help = /** @type {((inputs?: Subtitle_Export_Mxf_Wrap_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Mxf_Wrap_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_mxf_wrap_help(inputs)
	if (locale === "de") return de_subtitle_export_mxf_wrap_help(inputs)
	if (locale === "it") return it_subtitle_export_mxf_wrap_help(inputs)
	if (locale === "ru") return ru_subtitle_export_mxf_wrap_help(inputs)
	if (locale === "es") return es_subtitle_export_mxf_wrap_help(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_mxf_wrap_help(inputs)
	if (locale === "ja") return ja_subtitle_export_mxf_wrap_help(inputs)
	if (locale === "hi") return hi_subtitle_export_mxf_wrap_help(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_mxf_wrap_help(inputs)
	return en_subtitle_export_mxf_wrap_help(inputs)
});